<template>
  <div class="d-flex">
    <span v-for="prop in header.computed" :key="prop">{{ item[prop] }} </span>
  </div>
</template>

<script>
export default {
  name: 'ComputedTextContent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    header: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
